import { CardPreview } from "./card-preview.js";
import { styles } from "./card-preview.styles.js";
import { template } from "./card-preview.template.js";
import { DesignSystem } from "../design-system.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-card-preview>
 */
export const definition = CardPreview.compose({
    name: `${DesignSystem.prefix}-card-preview`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=card-preview.definition.js.map